import { makeStyles } from "@material-ui/core/styles";
import Error from "../../../../../components/1elements/Icons/svg/modal/headerError.svg";
import Deletion from "../../../../../components/1elements/Icons/svg/modal/headerDeletion.svg";
import Activation from "../../../../../components/1elements/Icons/svg/modal/headerActivation.svg";
import Suspension from "../../../../../components/1elements/Icons/svg/modal/headerSuspension.svg";
import SaveCancel from "../../../../../components/1elements/Icons/svg/modal/headerSaveCancelation.svg";

const Header = ({ type, headerText }) => {
    const classes = useStyles();
    const headerConfig = {
        error: {
            text: "Error",
            icon: Error,
        },
        save: {
            text: "Save Changes",
            icon: SaveCancel,
        },
        cancellation: {
            text: "Cancel Changes",
            icon: SaveCancel,
        },
        activation: {
            text: "Flag For Activation",
            icon: Activation,
        },
        deletion: {
            text: "Flag For Deletion",
            icon: Deletion,
        },
        suspension: {
            text: "Flag For Suspention",
            icon: Suspension,
        },
        default: {
            text: "Attention",
            icon: Activation,
        },
    };

    const header = headerConfig[type] || headerConfig["default"];

    return (
      <div className={classes.root}>
        <img
          alt={type || 'default'}
          src={header.icon}
          className={classes.image}
        />
        {headerText || header.text}
      </div>
    )
};

export default Header;

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        height: "50px",
        backgroundColor: "#F1F1F1",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "20px",
        fontWeight: 700,
        lineHeight: "27px",
    },
    image: {
        width: "25px",
        height: "25px",
        marginRight: "10px",
    },
}));
